<template>
  <div class="contact-main-block w-100 relative" @keydown="keyDownEvent">
    <HeaderMenu :title="title" :routeBackName="routeBackName" />
    <div class="item" style="width:100%">
      <div>
        <input
          class="input-border"
          v-model="userName"
          :placeholder="$t('login.enterUserName')"
          @input="errorMessage = ''"
          type="mail"
        />
      </div>
      <div>
        <input
          class="input-border"
          v-model="password"
          :placeholder="$t('login.enterPassword')"
          @input="errorMessage = ''"
        />
      </div>
      <div class="flex-column flex-bet">
        <div
          class="btn btn-larg create-btn"
          :class="{ disable: dataNotFilled }"
          @click="createSubUser"
        >
          {{ $t("login.createUser") }}
        </div>
      </div>
    </div>
    <span class="text-gray error-msg">{{ errorMessage }}</span>
  </div>
</template>

<script>
import { addSubUser } from "@/services/login";
import menuService from "@/services/menu";
import { mapActions } from "vuex";
export default {
  data() {
    return {
      title: this.$t("login.createSubUser"),
      routeBackName: "savePersonalData",
      userName: "",
      password: "",
      errorMessage: "",
    };
  },
  computed: {
    dataNotFilled() {
      return this.userName.trim() == "" || this.password.trim() == "";
    },
  },
  methods: {
    ...mapActions("user", ["setSubUser"]),
    keyDownEvent(e) {
      switch (e.code) {
        case "Tab":
          e.cancelBubble = true;
      }
    },
    async createSubUser() {
      if (!this.userName.trim() || !this.password.trim()) return;
      let subUser = await addSubUser({
        username: this.userName,
        password: this.password,
      });
      if (!subUser) this.errorMessage = this.$t("login1.errorCreateUser");
      else if (subUser == "duplicate")
        this.errorMessage = this.$t("login.emailExists");
      else {
        menuService.openSavePersonalData();
        this.$notify({
          type: "success",
          message: this.$t("login.successCreateSubUser"),
          timeout: 2000,
        });

        this.$store.dispatch("personalAdditionsTabs/clearAllPersonalAdditions");
        this.$store.dispatch("books/resetActiveStore");

        this.setSubUser({
          subUserId: subUser.user.subUserId,
          subUserName: this.userName,
          token: subUser.token,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
$bg-color2: #f7f7f7;
$bg-color5: #f4f4f4;
.error-msg {
  color: red;
  font-size: 14px;
  padding-right: 20px;
}
.item {
  padding: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.create-btn.disable {
  background-color: gray !important;
}
.input-border {
  margin-bottom: 10px;
}
</style>
